// ponytail: v6 dropped withRouter. Shim wraps useNavigate + useLocation + useParams
// and injects a v5-shaped `history` prop for class components mid-migration.
// Deprecate as classes migrate to hooks.
import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

export function withRouter(Component) {
  return function WithRouter(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const history = {
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      go: (n) => navigate(n),
      location,
    };
    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        match={{ params }}
        history={history}
      />
    );
  };
}

export default withRouter;
